import React from 'react';
import { useVideoConfig, spring, AbsoluteFill, Img, staticFile, interpolate, useCurrentFrame, Easing  } from "remotion";
import '../../App.css';
import { Background } from './TitleCardBackground';
import { loadFont } from "@remotion/google-fonts/OpenSans";


export const TitleCard = ({ title, BGcolor, GraphicDuration }) => {

  
const frame = useCurrentFrame();
const { fps } = useVideoConfig();
const GraphicDurationNum = parseInt(GraphicDuration);
const { height } = useVideoConfig();
const { fontFamily } = loadFont();


const AnimateOn = spring({
  fps,
  frame,
  from: height,
  to: 0,
  config: {
    stiffness: 50,
        },

  durationInFrames: 20,
});


const AnimateOff = interpolate(
  frame, 
  [(GraphicDurationNum-10), GraphicDurationNum],
  [0, height/2],
  {
    easing: Easing.back(2),
    extrapolateRight: "clamp",
    extrapolateLeft: "clamp",
  });

const TitleAnimation = AnimateOn + AnimateOff;


const opacity = interpolate(
  frame, 
  [(GraphicDurationNum-10), GraphicDurationNum],
  [1, 0],
  {
    extrapolateRight: "clamp",
  });

  return (
    <>
    <absoluteFill>
      <Background BGcolor={BGcolor} GraphicDuration={GraphicDuration}/>
    </absoluteFill>

    <absoluteFill
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',  
          justifyContent: 'center',
          alignItems: 'center',

        }}
        >
                  <div className='title_white'
                    style={{
                    backgroundColor:'white',
                    color: BGcolor,
                    textAlign: 'center',
                    fontSize: '4em',
                    fontFamily: fontFamily,
                    fontWeight: '900',
                    paddingTop: '1rem',
                    paddingBottom: '1rem',
                    paddingLeft: '1.5rem',
                    paddingRight: '1.5rem',
                    marginLeft: '5rem',
                    marginRight: '5rem',
                    borderRadius: '1rem',
                    transform: `translateY(${TitleAnimation}px)`,
                    opacity: opacity,
                  }}>
          {title}

          </div>



        </absoluteFill>
        </>
  );
};


